// extracted by mini-css-extract-plugin
export default {"loginForm":"RegularLoginForm_loginForm__NPuGe","formLabel":"RegularLoginForm_formLabel__C1JnV"};